import { http } from "./http";

const ENDPOINTS = {
  CHECK_PVC_NUMBER: "/contracts/check-pvc-number/",
};

export const contractAPI = {
  // pvc_number resets each year in reality, so availability is checked per
  // (pvc_number, year), not globally.
  checkPvcNumber: (pvcNumber, year) =>
    http.get(ENDPOINTS.CHECK_PVC_NUMBER, { params: { pvc_number: pvcNumber, year } }),
};
